
<div class="container">
  <div class="text-left">
      <div class="breadcrumb flat">
          <a [routerLink]="['/pos']">
              <!-- <em _ngcontent-lhx-c3="" class="icon-home" style="width: 1.8em;"></em> -->
              Home
          </a>
          <a href="#" class="active">New Tender</a>
      </div>
  </div>
  <div>
      <form #fnewprepaidcard="ngForm">
          <div class="content bg-light">
              <div class="container">
                  <div class="row">
                      <div class="col-md-12" *ngIf="isNewtender">
                          <div class="card card-outline-secondary">
                              <div class="card-header blue-bg">
                                  <h4 class="mb-0">Lets create a  New Tender. </h4>
                              </div>
                              <div class="card-body shadow right-img">
                                  <!-- <h6 class="blue-t">Lets create a  New Tender. </h6> -->
                                  <div class="row m-0">
                                      <div class="col-md-7 mb-3 bg-light cover">
                                          <form #form="ngForm" class="addpaynow">
                                              <div class="form-group">

                                                  <div class="row pt-2">

                                                        <div class="col-md-5 col-lg-4">
                                                          <label for="sel1">Payment Name<span
                                                                  class="text-danger">*</span></label>
                                                      </div>
                                                       <div class="col-md-1  d-none d-md-block"> : </div>
                                                        <div class="col-md-6 col-lg-7">
                                                          <div class="damke_input-wrapper"> 
                                                            <input matInput placeholder="Payment Name" id="TenderName" name="TenderName" [formControl]="TenderName"
                                                            required>
                                                          
                                          
                                                      </div>
                                                      <span class="text-danger" *ngIf="TenderName.invalid && (TenderName.dirty || TenderName.touched)">{{tendernameError()}}</span>
                                                  </div>
                                                  </div>
                                                  
                                                  <div class="row pt-2">

                                                        <div class="col-md-5 col-lg-4">
                                                          <label for="sel1">Payment Type <span
                                                                  class="text-danger">*</span></label>
                                                      </div>
                                                       <div class="col-md-1  d-none d-md-block"> : </div>
                                                        <div class="col-md-6 col-lg-7">
                                                          <div class="damke_input-wrapper">
                                                            <!-- <input id="TenderType" placeholder="Payment Type" name="TenderType"  [formControl]="TenderType" required (change)=onChange()> -->
                                                            <ngx-select [items]="Type" id="TenderType" placeholder="Payment Type" name="TenderType"  [formControl]="TenderType" required (change)=onChange()>
                                                            </ngx-select>
                                           
                                                          </div>
                                                          <span class="text-danger" *ngIf="TenderType.invalid && (TenderType.dirty || TenderType.touched)">{{tendertypeerrors()}}</span>
                                                        </div>
                                                  </div>
                                                
                                                
                                                  <div class="row pt-2">

                                                    <div class="col-md-5 col-lg-4">
                                                      <label for="sel1">TenderAccepted <span
                                                              class="text-danger"></span></label>
                                                  </div>
                                                   <div class="col-md-1  d-none d-md-block"> : </div>
                                                    <div class="col-md-6 col-lg-7">
                                                      <div class=""> 
                                                       
                                                        <!-- <input type="checkbox"  [(ngModel)]="isTenderAccepted" id="TenderAccepted" name="TenderAccepted" (click)="TenderAccepted1()"> -->
                                                  </div>
                                              </div>
                                              </div>
                                          
                                              <div class="row pt-2">

                                                <div class="col-md-5 col-lg-4">
                                                  <label for="sel1">OpenCashDrawer<span
                                                          class="text-danger"></span></label>
                                              </div>
                                               <div class="col-md-1  d-none d-md-block"> : </div>
                                                <div class="col-md-6 col-lg-7">
                                                  <div class=""> 
                                                  
                                                    <input type="checkbox" ngModel="isOpenCashDrawer" id="OpenCashDrawer" name="OpenCashDrawer" (click)="OpenCashDrawer1()">
                                              </div>
                                          </div>
                                          </div>
                                          
                                              
                                          

                                                  <div class="text-right pt-3">
                                                      <button class="btn damke_siteBtn" type="button" id="businesshourse" color="primary" 
                                                      [disabled]="TenderName.invalid "   
                                                     
                                                      (click)="newtender()">Submit</button>
                                                      <!-- || TenderType.invalid -->

                                                  </div>

                                              </div>
                                          </form>
                                      </div>
                                      <div class="col-md-5">
                                        <div class="col-12 col-md-10">
                                          <div class="border w-75  d-block mx-auto mx-md-0">
                                                  <h4 class="blue-t py-2 text-center">Quick Links</h4>
                                                  <ul class="list-group list-group-flush">
                                                      <li class="list-group-item"><a [routerLink]="['/pos']">Home</a></li>
                                                      <!-- <li class="list-group-item"><a [routerLink]="['/ecomsolutions/Paynow/new']">New Pay Now</a></li> -->

                                                      <li class="list-group-item"><a [routerLink]="['/pos/tender/manage']">Manage Tender</a> </li>
                                                      <!-- <li class="list-group-item"><a [routerLink]="['/reports/transactions/summary']">Reports</a></li> -->
                                                  </ul>
                                              </div>
                                          </div>
                                          <div class="pt-2">
                                              <h4 class="blue-t p-2" style="font-family: 'Oswald', sans-serif;"></h4>
                                              <carousel [itemsPerSlide]="1" [singleSlideOffset]="false" [noWrap]="false" [interval]="3000" [startFromIndex]="0">

                                                  <slide>
                                                      <a [routerLink]="['/transactions/faqs']"><img src="assets/img/collecting-money.png" alt="Tips" style="display: block; width: 100%;"></a>
                                                  </slide>
                                                  <slide>
                                                      <a [routerLink]="['/transactions/faqs']"><img src="assets/img/secure-gateway.png" alt="Tips" style="display: block; width: 100%;"></a>
                                                  </slide>
                                              </carousel>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </form>
  </div>

</div>




<div class="container">
 
  <div>
      <form #fnewprepaidcard="ngForm">
          <div class="content bg-light">
              <div class="container">
                  <div class="row">
                      <div class="col-md-12" *ngIf="isUpdatetender">
                          <div class="card card-outline-secondary">
                              <div class="card-header blue-bg">
                                  <h4 class="mb-0">Lets Update New Tender. </h4>
                              </div>
                              <div class="card-body shadow right-img">
                                  <!-- <h6 class="blue-t">Lets Tender. </h6> -->
                                  <div class="row m-0">
                                      <div class="col-md-7 mb-3 bg-light cover">
                                          <form #form="ngForm" class="addpaynow">
                                              <div class="form-group">

                                                  <div class="row pt-2">

                                                        <div class="col-md-5 col-lg-4">
                                                          <label for="sel1">Payment Name<span
                                                                  class="text-danger">*</span></label>
                                                      </div>
                                                       <div class="col-md-1  d-none d-md-block"> : </div>
                                                        <div class="col-md-6 col-lg-7">
                                                          <div class="damke_input-wrapper"> 
                                                            <input matInput placeholder="Payment Name" id="TenderName" name="TenderName" [(ngModel)]="rows.TenderName" [formControl]="TenderName" [(ngModel)]="rows.tenderName"
                                                            required>
                                                          
                                          
                                                      </div>
                                                      <span class="text-danger" *ngIf="TenderName.invalid && (TenderName.dirty || TenderName.touched)">{{tendernameError()}}</span>
                                                  </div>
                                                  </div>
                                                  
                                                  <div class="row pt-2">

                                                        <div class="col-md-5 col-lg-4">
                                                          <label for="sel1">Payment Type <span
                                                                  class="text-danger">*</span></label>
                                                      </div>
                                                       <div class="col-md-1  d-none d-md-block"> : </div>
                                                        <div class="col-md-6 col-lg-7">
                                                          <div class="damke_input-wrapper">
                                                   
                                                            <ngx-select [items]="Type" id="TenderType" placeholder="Payment Type" name="TenderType"    [formControl]="TenderType" [(ngModel)]="tender" required (change)=onChange()>
                                                            </ngx-select>
                                           
                                                          </div>
                                                          <span class="text-danger" *ngIf="TenderType.invalid && (TenderType.dirty || TenderType.touched)">{{tendertypeerrors()}}</span>
                                                        </div>
                                                  </div>
                                                
                                                
                                                  <div class="row pt-2">

                                                    <div class="col-md-5 col-lg-4">
                                                      <label for="sel1">TenderAccepted <span
                                                              class="text-danger"></span></label>
                                                  </div>
                                                   <div class="col-md-1  d-none d-md-block"> : </div>
                                                    <div class="col-md-6 col-lg-7">
                                                      <div class=""> 
                                                       
                                                        <input type="checkbox"  [(ngModel)]="TenderAccepted" id="TenderAccepted" name="TenderAccepted" (click)="TenderAccepted1()">
                                                  </div>
                                              </div>
                                              </div>
                                          
                                              <div class="row pt-2">

                                                <div class="col-md-5 col-lg-4">
                                                  <label for="sel1">OpenCashDrawer<span
                                                          class="text-danger"></span></label>
                                              </div>
                                               <div class="col-md-1  d-none d-md-block"> : </div>
                                                <div class="col-md-6 col-lg-7">
                                                  <div class=""> 
                                                  
                                                    <input type="checkbox" [(ngModel)]="OpenCashDrawer" id="OpenCashDrawer" name="OpenCashDrawer" (click)="OpenCashDrawer1()">
                                              </div>
                                          </div>
                                          </div>
                                          <input type="hidden" [(ngModel)]="rows.Id" id="id" name="id"  [formControl]="id" >
                                         
                                          <input type="hidden" [(ngModel)]="rows.DateTime" id="datetime" name="datetime"  [formControl]="dateTime" >
                                          
                                          

                                                  <div class="text-right pt-3">
                                                      <button class="btn damke_siteBtn" type="button" id="businesshourse" color="primary" 
                                                      [disabled]="TenderName.invalid"   
                                                      (click)="Updatetender()">Update</button>
                                                      <!-- || TenderType.invalid -->
                                                  </div>

                                              </div>
                                          </form>
                                      </div>
                                      <div class="col-md-5">
                                        <div class="col-12 col-md-10">
                                          <div class="border w-75  d-block mx-auto mx-md-0">
                                                  <h4 class="blue-t py-2 text-center">Quick Links</h4>
                                                  <ul class="list-group list-group-flush">
                                                      <li class="list-group-item"><a [routerLink]="['/pos']">Home</a></li>
                                                      <!-- <li class="list-group-item"><a [routerLink]="['/ecomsolutions/Paynow/new']">New Pay Now</a></li> -->

                                                      <li class="list-group-item"><a [routerLink]="['/pos/tender/manage']">ManageTender</a> </li>
                                                      <li class="list-group-item"><a [routerLink]="['/reports/transactions/summary']">Reports</a></li>
                                                  </ul>
                                              </div>
                                          </div>
                                          <div class="pt-2">
                                              <h4 class="blue-t p-2" style="font-family: 'Oswald', sans-serif;"></h4>
                                              <carousel [itemsPerSlide]="1" [singleSlideOffset]="false" [noWrap]="false" [interval]="3000" [startFromIndex]="0">

                                                  <slide>
                                                      <a [routerLink]="['/transactions/faqs']"><img src="assets/img/collecting-money.png" alt="Tips" style="display: block; width: 100%;"></a>
                                                  </slide>
                                                  <slide>
                                                      <a [routerLink]="['/transactions/faqs']"><img src="assets/img/payment-solutions.png" alt="Tips" style="display: block; width: 100%;"></a>
                                                  </slide>
                                              </carousel>
                                          </div>
                                      </div>
                                  </div>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </form>
  </div>

</div>